export enum PaymentPlanLineTableAction {
  SEND_PAYMENT_NOTIFICATION = 'send_payment_notification',
  SEE_PAYMENT_ATTEMPTS = 'see_payment_attempts',
  UPDATE_PAYMENT_PLAN_LINE_STATUS = 'update_payment_plan_line_status',
  UPDATE_PAYMENT_PLAN_LINE_QUOTA_AMOUNT = 'update_payment_plan_line_quota_amount',
  UPDATE_PAYMENT_PLAN_LINE_PAYMENT_DATE = 'update_payment_plan_line_payment_date',
  UPDATE_PAYMENT_PLAN_LINE_DUE_DATE = 'update_payment_plan_line_due_date',
}
